import qs from 'query-string';

type LocationCompatible = {
	search: string;
	origin: string;
	hash: string;
};

export const getPlanId = (loc: LocationCompatible): number => {
	const parsed = qs.parse(loc.search);
	return parseInt(parsed.id, 10);
};

export const getWizardVersion = (loc: LocationCompatible): number => {
	const parsed = qs.parse(loc.search);
	return parseInt(parsed.wizardversion, 10);
};

export const stripPlanWizardParams = (loc: LocationCompatible): string => {
	const parsed = qs.parse(loc.search);
	const nextQueryPayload = { ...parsed };

	delete nextQueryPayload.wizardversion;

	const nextQuery = `?${qs.stringify(nextQueryPayload)}`;

	return `${loc.origin}${nextQuery}${loc.hash}`;
};
